<template>
  <Card class="statistics-sales-residentials">
    <template #default>
      <slot name="top" />
      <Loader :value="promise" theme="default">
        <LineChart
          v-if="data"
          class="statistics-sales-residentials__chart"
          :chart-data="chartData"
          :options="chartOptions"
        />
      </Loader>
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </Card>
</template>

<script>
import moment from 'moment'
import API from '@/api/Statistics'

import LineChart from '@/components/Charts/ChartJS/Line'
import Card from '@/components/Card'

export default {
  props: {
    project: String,
  },
  watch: {
    filter: {
      handler: 'fetch',
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      data: null,
      divider: {
        value: 1000000,
        suffix: 'M',
      },
      range: {
        start: moment().startOf('year'),
        end: moment().endOf('year'),
      },
    }
  },
  computed: {
    title() {
      return `${this.$t('statisticsSalesResidentials')} - ${this.range.start.year()}`
    },
    filter() {
      return {
        range: this.range,
        project: this.project,
      }
    },
    chartData() {
      return {
        type: 'line',
        labels: moment.monthsShort(),
        datasets: [
          {
            backgroundColor: this.getColor('primary', 0.2),
            borderColor: this.getColor('primary'),
            fill: true,
            cubicInterpolationMode: 'monotone',
            data: Array.from({ length: 12 }).map((i, index) => {
              return (
                this.data
                  .filter(e =>
                    e.date.startsWith(`${this.range.start.year()}-${(index + 1).toString().padStart(2, '0')}`),
                  )
                  .reduce((sum, e) => sum + e.value, 0) / this.divider.value
              )
            }),
          },
        ],
      }
    },
    chartOptions() {
      return {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            grid: {
              display: true,
            },
            ticks: {
              callback: value => {
                return value + this.divider.suffix
              },
            },
          },
          x: {
            grid: {
              display: false,
            },
          },
        },
      }
    },
  },
  methods: {
    fetch() {
      this.data = null
      this.promise = API.getSalesResidential({ filter: this.filter }).then(data => (this.data = data))
    },
    getColor(key, opacity = 1) {
      let [h, s, l] = ['h', 's', 'l'].map(k =>
        getComputedStyle(document.documentElement).getPropertyValue(`--${key}-${k}`),
      )

      return `hsla(${h}, ${s}, ${l}, ${opacity})`
    },
  },
  components: {
    Card,
    LineChart,
  },
}
</script>

<style lang="scss">
.statistics-sales-residentials {
  &__chart {
    height: 350px;
  }
}
</style>
